<template>
  <LoadingWrapper :state="status">
    <PrepareSuperpowerSlideAnalysis
      :feedback-topic-id="feedbackTopicId"
      :superpower-survey-id="data?.superpowerSurveyId"
      :slide-properties="data.slideProperties"
      :superpower="data?.superpower"
      :spontaneous-feedbacks="data?.spontaneousFeedbacks"
      @dirty="setDirty"
    />
    <UnsavedChangesDialog
      :is-open="showConfirmDialog"
      @confirm="confirmLeave"
      @dismiss="cancelLeave"
    />
  </LoadingWrapper>
</template>
<script lang="ts" setup>
  import LoadingWrapper from '../../../core/components/loading/LoadingWrapper.vue'
  import { usePrepareSuperpowerSlide } from '../composable/use-prepare-superpower-slide'
  import PrepareSuperpowerSlideAnalysis from './PrepareSuperpowerSlideAnalysis.vue'
  import { useRoute } from 'vue-router'
  import { useUnsavedChanges } from '@/core/composables/use-unsaved-changes'
  import UnsavedChangesDialog from '@/core/components/unsaved-changes-dialog/UnsavedChangesDialog.vue'

  const route = useRoute()

  const feedbackTopicId = route.params.feedbackTopicId as string
  const { status, data, } =
    usePrepareSuperpowerSlide(feedbackTopicId)

  const { showConfirmDialog, confirmLeave, cancelLeave, setDirty } = useUnsavedChanges()

</script>
